<template>
  <div style="padding-bottom:50px">
    <van-row>
      <van-col :span="24" class="bg-white data m-t-05" v-for="(item,index) in dataList" :key="index">
        <van-row>
          <van-col :span="4">
            <svg class="icon" aria-hidden="true" style="font-size:2.2rem">
              <use :xlink:href="iconClassName(item.type)"></use>
            </svg>
          </van-col>
          <van-col :span="16">
            <div class="van-multi-ellipsis--l2 f-s-7" style="color:#292E35">
              {{item.dtitle}}
            </div>
            <p class="f-s-7" style="color:#73787F">大小:{{item.size}}</p>
          </van-col>
           <van-col :span="4">
            <van-icon :name="down" size="2.2rem" @click="viewData(item)" />
          </van-col>
        </van-row>
      </van-col>
    </van-row>
    <input v-model="shareUrl" id="express_info_right" type="text" style='opacity: 0;position: absolute;' />

  </div>
</template>

<script>
import "@/assets/icon/iconfont.js"
export default {
  props:{
    dataList:{
      type:Array,
      default:() => {
        return []
      }
    }
  },
  data(){
    return{
      folder:require("@/assets/imgs/folder.png"),
      down:require("@/assets/imgs/mine/down.png"),
      shareUrl:""
    }
  },
  methods:{
    // 查看资料
    viewData(item){
      switch(item.type){
        case 'pdf':
          window.open(item.durl)
          break;
        case 'docx':
          window.open(item.durl)
          break;
        case 'ppt':
          window.open(item.durl)
          break;
        default:
          this.$dialog.alert({
            title:"提示",
            message: item.type + '文件暂时无法在线查看,点击确定后复制到浏览器下载',
          }).then(() => {
            this.shareUrl = item.durl
            var ShareUrl = document.getElementById("express_info_right")
            ShareUrl.select()
            if(document.execCommand("copy")){
              this.$toast('复制成功');
            }else {
              this.$toast('复制失败');
            }
          })
          // this.$toast(item.type + '文件暂时无法在线查看');
      }
    }
  },
  watch:{
    dataList:{
      deep:true,
      immediate:true,
      handler(val){
        if(val == []) return false
        val.forEach(item => {
          item.type = item.dtitle.substring(item.dtitle.indexOf('.')+1).toLowerCase()
        });
      }
    }
  }
}
</script>

<style lang="less" scoped>

@import "//at.alicdn.com/t/font_2499979_etw8ns6bg4h.css";
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.data {
  padding-left:0.5rem ;
  padding-top:0.5rem;
}
</style>